module.exports = "<p>\r\n  estadistica works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/estadistica/estadistica.component.html
// module id = ../../../../../src/app/components/estadistica/estadistica.component.html
// module chunks = main